<template>
  <div>
    <v-simple-table fixed-header fixed-footer height="350px" class="elevation-0">
      <template v-slot:default>
        <thead>
          <tr>
            <th v-if="checkbox" style="width: 42px;"></th>
            <th class="text-left">Date Received</th>
            <th class="text-left">Serial Number</th>
            <th class="text-left">Cost</th>
            <th class="text-left">Amount sold</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in inventories" :key="item.id" style="cursor: pointer">
            <td v-if="checkbox">
              <input
                type="checkbox"
                v-model="inventoryChecked"
                :ref="`inventory${item.id}`"
                :value="item.serial"
              />
            </td>
            <td class="text-left">{{ item.date_received }}</td>
            <td class="text-left">{{ item.serial }}</td>
            <td class="text-left">{{ parseFloat(item.cost).toLocaleString() }}</td>
            <td class="text-left">{{ (parseFloat(item.amount) || '').toLocaleString() }}</td>
          </tr>
          <tr v-if="inventories.length == 0">
            <td colspan="5" style="height:300px;text-align: center">
              No records found
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-card elevation="0">
      <v-card-actions>
        <v-btn v-if="inventoryChecked.length == 0" outlined color="green" @click="checkAll">
          Select all
        </v-btn>
        <v-btn v-if="inventoryChecked.length > 0" outlined color="green" @click="clear">
          Clear
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="inventoryChecked.length == 0"
          outlined
          color="green"
          @click="generateBarcode"
        >
          Print Barcode
        </v-btn>
        <v-btn
          :disabled="inventoryChecked.length == 0"
          outlined
          color="green"
          @click="generateTextFile"
        >
          Download text file
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { unparse } from 'papaparse';
import { saveAs } from 'file-saver';

export default {
  props: ['inventories', 'checkbox'],
  data: function() {
    return {
      print: false,
      inventoryChecked: [],
      json_data: []
    };
  },
  computed: {
    ...mapState({
      product(state) {
        return state.Product.product.data;
      }
    })
  },
  methods: {
    ...mapActions(['openBarCodePrint', 'setBarcodes']),
    clear() {
      this.inventoryChecked = [];
    },
    checkAll() {
      this.inventoryChecked = this.inventories.map(inventory => inventory.serial);
    },
    generateBarcode() {
      this.openBarCodePrint();
      this.setBarcodes(this.inventoryChecked);
    },
    generateTextFile() {
      let barcode_data = this.inventoryChecked.map(inventory => [inventory, this.product.price]);
      let csv = unparse(barcode_data, { delimiter: '\t' });
      let blob = new Blob([csv], {
        type: 'application/csvcharset=utf8'
      });

      saveAs(blob, 'barcodedb.txt');
    }
  }
};
</script>
